import { AlertTriangle } from 'lucide-react'

export function LegalBanner() {
  return (
    <section className="max-w-5xl mx-auto px-5 py-8">
      <div className="rounded-2xl border border-border bg-panel/40 p-5 flex gap-4">
        <div className="flex-shrink-0 mt-0.5">
          <AlertTriangle className="h-5 w-5 text-text-dim/60" />
        </div>
        <div className="space-y-1">
          <p className="text-xs font-semibold text-text-dim uppercase tracking-wider">
            Aviso legal
          </p>
          <p className="text-xs text-text-dim leading-relaxed">
            John Anthony ofrece análisis estadístico e información con fines exclusivamente informativos.{' '}
            <strong className="text-text/70">No garantiza beneficios ni resultados económicos.</strong>{' '}
            Las apuestas deportivas implican riesgo económico y pueden generar pérdidas.
            Servicio dirigido únicamente a <strong className="text-text/70">mayores de 18 años</strong>.
            Si crees que el juego está afectando tu vida, busca ayuda en{' '}
            <a
              href="https://www.jugarbien.es"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-brand transition-colors"
            >
              jugarbien.es
            </a>{' '}
            o{' '}
            <a
              href="https://www.fejar.org"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-brand transition-colors"
            >
              fejar.org
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  )
}
